/* =========================================================
   Peak Herbs — Attune experience system  (portable component)
   ---------------------------------------------------------
   "The Sanctuary" build. Two IIFEs: weather particles
   and the engine.

   CONTROL = a responsive ‹ value › stepper stack. Each dimension
   (Mode · Weather · Sound · Motion · Text) cycles through values;
   tap an edge arrow, the centre value + the atmosphere change.
   Sound opens a draggable volume bar (Off–5) with −/+ steppers.
   The Hearth is a wordless ember; tap kindles a real fire (GSAP).

   Pairs with peak-attune.css + the head FOUC guard + markup snippets.
   GSAP (window.gsap) is OPTIONAL — every motion has an instant CSS
   fallback, so the page never breaks if GSAP is absent.
   ========================================================= */

// ---- Weather particles (motes / rain / stars) — counts bumped on mobile so effects read on a phone ----
(function () {
  var mobile = window.innerWidth <= 640, rnd=function(a,b){return a+Math.random()*(b-a);};
  function make(parent,n,build){ if(!parent) return; var f=document.createDocumentFragment(); for(var i=0;i<n;i++) f.appendChild(build(i)); parent.appendChild(f); }
  make(document.getElementById('amb-motes'), mobile?12:15, function(){ var d=document.createElement('span'); d.className='mote';
    d.style.cssText='--x:'+rnd(4,96)+'%;--y:'+rnd(15,85)+'%;--s:'+rnd(3,6).toFixed(1)+'px;--dx:'+rnd(-26,26).toFixed(0)+'px;--dy:'+rnd(-46,-14).toFixed(0)+'px;--d:'+rnd(34,60).toFixed(0)+'s;--delay:-'+rnd(0,40).toFixed(0)+'s'; return d; });
  make(document.getElementById('amb-rain'), mobile?58:74, function(){ var d=document.createElement('span'); d.className='rdrop';
    d.style.cssText='--x:'+rnd(0,100)+'%;--h:'+rnd(22,52).toFixed(0)+'px;--w:'+rnd(1.2,2.0).toFixed(2)+'px;--o:'+rnd(.38,.62).toFixed(2)+';--d:'+rnd(4.6,8.2).toFixed(2)+'s;--wind:'+rnd(0.3,1.4).toFixed(2)+'vw;--delay:-'+rnd(0,8.2).toFixed(2)+'s'; return d; });
  make(document.getElementById('stars'), mobile?40:54, function(){ var d=document.createElement('span'); d.className='star';
    d.style.cssText='--x:'+rnd(2,98)+'%;--y:'+rnd(2,70)+'%;--s:'+rnd(1.4,2.6).toFixed(1)+'px;--t:'+rnd(4,9).toFixed(1)+'s;--td:-'+rnd(0,8).toFixed(1)+'s'; return d; });
  make(document.getElementById('biolum'), mobile?10:14, function(){ var d=document.createElement('span'); d.className='glow';
    d.style.cssText='--x:'+rnd(6,94)+'%;--y:'+rnd(12,86)+'%;--s:'+rnd(3,7).toFixed(1)+'px;--dx:'+rnd(-22,22).toFixed(0)+'px;--dy:'+rnd(-30,-10).toFixed(0)+'px;--d:'+rnd(26,46).toFixed(0)+'s;--delay:-'+rnd(0,40).toFixed(0)+'s;--bt:'+rnd(4.5,8).toFixed(1)+'s;--bd:-'+rnd(0,8).toFixed(1)+'s;--mo:'+rnd(.45,.8).toFixed(2); return d; });
})();

// ---- Attune engine ----
(function () {
  var GS = window.gsap || null, REDUCE = false;
  try{ REDUCE = matchMedia('(prefers-reduced-motion: reduce)').matches; }catch(e){}
  if(GS && REDUCE) GS=null;
  window.__paUseGSAP = function(){ if(!REDUCE && window.gsap) GS = window.gsap; };  // GSAP lazy-loads on first interaction, then wires in here

  // Haptic tick — a real buzz on phones. navigator.vibrate covers Android; iOS 17.4+ gets a best-effort
  // pulse via the hidden <input switch> trick. No-op on desktop and when the OS asks for reduced motion.
  var HAPT = (function(){
    var coarse=false; try{ coarse = matchMedia('(pointer: coarse)').matches; }catch(e){}
    var iosEl=null;
    function ensureIOS(){ if(iosEl || !coarse) return; try{
      var l=document.createElement('label'); l.setAttribute('aria-hidden','true');
      l.style.cssText='position:fixed;top:-100px;left:-100px;width:0;height:0;opacity:0;pointer-events:none;';
      var i=document.createElement('input'); i.type='checkbox'; i.setAttribute('switch',''); l.appendChild(i);
      (document.body||document.documentElement).appendChild(l); iosEl=l;
    }catch(e){} }
    return function(kind){
      if(!coarse || REDUCE) return;
      try{
        if(navigator.vibrate){ navigator.vibrate(kind==='ignite'?[10,35,18]:(kind==='douse'?15:8)); }
        else { ensureIOS(); if(iosEl) iosEl.click(); }
      }catch(e){}
    };
  })();   // ignite/flip/stagger fall back to instant state changes

  var KEY=window.__paKEY||'peakherbs_attune_v2';
  var prefs=window.__paPrefs||{mode:'auto',weather:'auto',text:'md',sound:'off',motion:'on'};
  if(['off','1','2','3','4','5'].indexOf(prefs.sound)<0) prefs.sound='off';
  prefs.sound='off';  // sound is a per-session opt-in — always starts OFF (autoplay is blocked anyway)
  var resolveMode=window.__paResolveMode||function(m){return m==='auto'?'light':m;};
  var resolveWeather=window.__paResolveWeather||function(w,m){ if(w&&w!=='auto') return w; if(m==='dark') return 'aurora'; if(m==='dim') return 'rain'; return 'clear'; };
  var html=document.documentElement;
  var segSync=null;   // set by the segmented picker below so refresh() keeps the option pips in sync
  function save(){ try{ localStorage.setItem(KEY, JSON.stringify(prefs)); }catch(e){} }

  // ---- Ambient audio mapped to WEATHER (crossfaded). On Shopify, window.PEAK_AMB overrides the URLs. ----
  var AMB = window.PEAK_AMB ? { clear:window.PEAK_AMB.clear, rain:window.PEAK_AMB.rain, aurora:window.PEAK_AMB.aurora }
                            : { clear:'peak-amb-clear.mp3', rain:'peak-amb-rain.mp3', aurora:'peak-amb-aurora.mp3' };
  var SND={ off:0, '1':0.12, '2':0.22, '3':0.34, '4':0.47, '5':0.60 };   // Sound level (0-5) -> ambient gain (never loud)
  var aA=document.getElementById('amb-audio-a'), aB=document.getElementById('amb-audio-b');
  var act=aA, sby=aB, VOL=SND[prefs.sound]||0, curW=null; if(aA) aA.volume=0; if(aB) aB.volume=0;
  function fade(el,from,to,ms,done){ if(!el){ if(done) done(); return; }
    var id=(el.__fid=(el.__fid||0)+1), t0=performance.now();
    function step(ts){ if(el.__fid!==id) return; var k=Math.min((ts-t0)/ms,1); var e=k*k*(3-2*k); el.volume=Math.max(0,Math.min(1,from+(to-from)*e)); if(k<1) requestAnimationFrame(step); else if(done) done(); }
    requestAnimationFrame(step); }
  function playWeather(w, cross){ if(!act){ return; } var src=AMB[w]||AMB.clear; if(!src){ return; } curW=w;
    if(!cross){ act.src=src; act.volume=0; var p=act.play(); if(p&&p.catch)p.catch(function(){}); fade(act,0,VOL,1500); return; }
    var old=act, nw=sby;
    nw.src=src; nw.volume=0; var q=nw.play(); if(q&&q.catch)q.catch(function(){}); fade(nw,0,VOL,1200);
    fade(old,old.volume,0,1200,function(){ try{ old.pause(); }catch(e){} });
    act=nw; sby=old; }
  function soundOn(){ playWeather(primaryWeather(), false); }
  function soundOff(){ curW=null; if(act){ fade(act,act.volume,0,650,function(){ try{act.pause();}catch(e){} }); } if(sby){ try{sby.pause();}catch(e){} } }
  function syncSound(){ if(prefs.sound==='off') return; var w=primaryWeather(); if(w===curW) return; playWeather(w, curW!==null); }

  // ---- The Hearth (fire) — wordless ember; tap kindles. Glow is visual; crackle needs Sound on + a clip. ----
  var FIRE='peakherbs_attune_fire';
  var fireAudio=document.getElementById('amb-fire'), hearth=document.getElementById('pa-hearth');
  var fireOn=false;  // Hearth starts unlit every visit — the resting state is the inviting ember, not fire
  function fireSound(play){ if(!fireAudio) return; if(play){ if(!fireAudio.getAttribute('src')) fireAudio.setAttribute('src',(window.PEAK_AMB&&window.PEAK_AMB.fire)||'peak-amb-fire.mp3'); fireAudio.volume=0; var p=fireAudio.play(); if(p&&p.catch)p.catch(function(){}); fade(fireAudio,0,VOL*0.9,900); } else { fade(fireAudio,fireAudio.volume||0,0,500,function(){ try{fireAudio.pause();}catch(e){} }); } }
  function applyFire(){ html.setAttribute('data-pa-fire', fireOn?'on':'off'); if(hearth) hearth.setAttribute('aria-pressed', fireOn?'true':'false'); if(fireOn && prefs.sound!=='off') fireSound(true); else fireSound(false); }
  // The Hearth reveal/hide is CSS (data-pa-fire → .pa-fire opacity transition) so it ALWAYS works.
  // GSAP only adds the one-shot kindle flourish (ember-glyph catch + a scaleY "rise" — transform only, no opacity conflict).
  function igniteAnim(){ if(!GS) return; var tl=GS.timeline();
    tl.fromTo('.pa-hearth svg',{scale:1},{scale:1.16,duration:.16,ease:'power2.out',yoyo:true,repeat:1,transformOrigin:'50% 60%'})
      .fromTo('.pa-fire',{scaleY:0.4},{scaleY:1,duration:.66,ease:'power3.out',transformOrigin:'50% 100%'},0.02); }
  function toggleHearth(){ fireOn=!fireOn; try{ localStorage.setItem(FIRE, fireOn?'1':'0'); }catch(e){}
    html.setAttribute('data-pa-fire', fireOn?'on':'off'); if(hearth) hearth.setAttribute('aria-pressed', fireOn?'true':'false');
    if(fireOn) igniteAnim();
    HAPT(fireOn?'ignite':'douse');
    if(fireOn && prefs.sound!=='off') fireSound(true); else fireSound(false); }
  if(hearth) hearth.addEventListener('click', function(e){ e.stopPropagation(); toggleHearth(); });

  // Weather is layerable: Rain + Aurora can both be on. prefs.weather token is
  // 'auto' | 'clear' | 'rain' | 'aurora' | 'rain+aurora'. These resolve it to flags.
  function weatherFlags(){
    var w = prefs.weather || 'auto';
    if(w==='auto'){ var m=resolveMode(prefs.mode); return { rain:(m==='dim'), aurora:(m==='dark') }; }
    if(w==='clear') return { rain:false, aurora:false };
    return { rain:(w==='rain'||w==='rain+aurora'), aurora:(w==='aurora'||w==='rain+aurora') };
  }
  function weatherToken(f){ return (f.rain&&f.aurora)?'rain+aurora':(f.rain?'rain':(f.aurora?'aurora':'clear')); }
  function primaryWeather(){ var f=weatherFlags(); return f.aurora?'aurora':(f.rain?'rain':'clear'); }   // sound maps to ONE track
  function applyAtmosphere(){
    var modeR = resolveMode(prefs.mode), f = weatherFlags();
    html.setAttribute('data-pa-mode', modeR);
    html.setAttribute('data-pa-rain', f.rain?'on':'off');
    html.setAttribute('data-pa-aurora', f.aurora?'on':'off');
    html.setAttribute('data-pa-weather', primaryWeather());   // kept for sound + dormant glyph rules
    html.setAttribute('data-pa-motion', prefs.motion||'on');
    html.setAttribute('data-pa-text', prefs.text||'md');
  }

  // ===== Stepper control =====
  var CYC = { mode:['auto','light','dim','dark'], weather:['auto','clear','rain','aurora'], sound:['off','1','2','3','4','5'], motion:['on','off'], text:['md','lg','xl'] };
  var LBL = {
    mode:{auto:'Auto',light:'Daybreak',dim:'Dusk',dark:'Nightfall'},
    weather:{auto:'Auto',clear:'Clear',rain:'Rain',aurora:'Aurora'},
    sound:{off:'Off','1':'Level 1','2':'Level 2','3':'Level 3','4':'Level 4','5':'Level 5'},
    motion:{on:'On',off:'Off'},
    text:{md:'Normal',lg:'Large',xl:'X-Large'}
  };
  function curVal(dim){ return prefs[dim] || CYC[dim][0]; }
  function setDimValue(dim,val){
    if(dim==='sound'){
      var was=prefs.sound; prefs.sound=val; VOL=SND[val]; save();
      if(val==='off') soundOff();
      else if(was==='off') soundOn();
      else { if(act && !act.paused) act.volume=VOL; if(fireOn && fireAudio && !fireAudio.paused) fireAudio.volume=VOL*0.9; }
      applyFire();
    } else if(dim==='mode' || dim==='weather'){
      prefs[dim]=val; save(); applyAtmosphere(); syncSound();
    } else { // motion / text
      prefs[dim]=val; save(); applyAtmosphere();
    }
    refresh();
  }
  function step(dim,dir){ var arr=CYC[dim], i=arr.indexOf(curVal(dim)); if(i<0)i=0; var n=(dim==='sound')?Math.max(0,Math.min(arr.length-1,i+dir)):(i+dir+arr.length)%arr.length; setDimValue(dim, arr[n]); HAPT('tick'); flipValue(dim,dir); }
  function indicatorText(){
    var rm=resolveMode(prefs.mode);
    // The pill greets the hour with one warm word (Daybreak / Dusk / Nightfall).
    // Weather + auto/manual detail live inside the open panel, keeping the pill quiet.
    return LBL.mode[rm]||'';
  }
  // semantic value colours (readable on light AND dark panels); '' → falls back to ink
  var COL = { mode:{light:'#C8842F',dim:'#A07FA8',dark:'#7C8DC4'}, weather:{clear:'#C9A23E',rain:'#5F8BC2',aurora:'#46A98A'},
    sound:{}, motion:{on:'#5E9276'}, text:{} };
  function soundLevel(val){ var k=CYC.sound.indexOf(val); return k<0?0:k; }   // 'off'->0 ... '5'->5
  function updateMeter(row,val){ var meter=row.querySelector('[data-meter]'); if(!meter) return; var lvl=soundLevel(val);
    var segs=meter.querySelectorAll('.pa-seg'); for(var i=0;i<segs.length;i++){ segs[i].classList.toggle('on', i<lvl); }
    meter.setAttribute('aria-valuenow', lvl); }
  function refresh(){
    document.querySelectorAll('.pa11y .pa-row[data-dim]').forEach(function(row){
      var dim=row.getAttribute('data-dim'), val=curVal(dim), cur=row.querySelector('[data-val]');
      if(dim==='sound') updateMeter(row, val);
      if(cur){
        if(dim==='mode' && val==='auto') cur.innerHTML='Auto<span class="pa-res"> · '+(LBL.mode[resolveMode('auto')]||'')+'</span>';
        else if(dim==='weather' && val==='auto') cur.innerHTML='Auto<span class="pa-res"> · '+(LBL.weather[resolveWeather('auto', resolveMode(prefs.mode))]||'')+'</span>';
        else cur.textContent=(LBL[dim]&&LBL[dim][val])||val;
      }
      row.setAttribute('data-cur', val);
      row.style.setProperty('--pa-row-col', (COL[dim]&&COL[dim][val])||'');   // tint the value with the option's semantic colour
    });
    var ind=document.getElementById('pa-indicator'); if(ind) ind.textContent=indicatorText();
    updateVol();
    if(segSync) segSync();
  }
  // value swap — the new value slides in from the pressed side (GSAP), or a quiet fade (fallback). Skipped under reduced-motion.
  function flipValue(dim,dir){
    if(dim==='sound') return;   // the sound meter animates itself; no text to flip
    var row=document.querySelector('.pa11y .pa-row[data-dim="'+dim+'"]'); if(!row) return;
    var cur=row.querySelector('[data-val]'); if(!cur || REDUCE) return;
    if(GS){ GS.killTweensOf(cur); GS.fromTo(cur,{x:dir>0?7:-7,opacity:0},{x:0,opacity:1,duration:.32,ease:'power3.out',clearProps:'transform,opacity'}); }
    else { cur.classList.remove('pa-flip'); void cur.offsetWidth; cur.classList.add('pa-flip'); }
  }

  // init (set the visual state before wiring)
  applyAtmosphere(); applyFire(); refresh();

  document.querySelectorAll('.pa11y [data-step]').forEach(function(b){ b.addEventListener('click', function(e){ e.stopPropagation(); step(b.getAttribute('data-step'), +b.getAttribute('data-dir')); }); });
  document.querySelectorAll('.pa11y .pa-row[data-dim]').forEach(function(row){ row.addEventListener('keydown', function(e){ if(e.key==='ArrowLeft'){ step(row.getAttribute('data-dim'),-1); e.preventDefault(); } else if(e.key==='ArrowRight'){ step(row.getAttribute('data-dim'),1); e.preventDefault(); } }); });

  // ===== Volume bar — the Sound toggle opens it; drag the bar or tap −/+ (Off–5, quantised, haptic tick per detent) =====
  var volWrap=document.getElementById('pa-vol'), volTrack=document.getElementById('pa-vol-track');
  var volRail=volWrap?volWrap.querySelector('.pa-vol__rail'):null, volLast='2';
  function updateVol(){ if(!volWrap) return; var lvl=soundLevel(prefs.sound);
    if(prefs.sound!=='off') volLast=prefs.sound;   // remember the last audible level so the toggle restores it
    volWrap.style.setProperty('--pa-vol-f', lvl/5);
    if(volTrack){ volTrack.setAttribute('aria-valuenow', lvl); volTrack.setAttribute('aria-valuetext', lvl===0?'Off':'Level '+lvl); } }
  function volOpen(){ if(!volWrap) return; volWrap.setAttribute('data-open','1'); volWrap.removeAttribute('aria-hidden');
    if(volTrack) volTrack.setAttribute('tabindex','0');
    volWrap.querySelectorAll('.pa-vol__btn').forEach(function(b){ b.removeAttribute('tabindex'); }); updateVol(); }
  function volClose(){ if(!volWrap) return; volWrap.setAttribute('data-open','0'); volWrap.setAttribute('aria-hidden','true');
    if(volTrack) volTrack.setAttribute('tabindex','-1');
    volWrap.querySelectorAll('.pa-vol__btn').forEach(function(b){ b.setAttribute('tabindex','-1'); }); }
  function soundToggle(){ if(prefs.sound==='off'){ setDimValue('sound', volLast); volOpen(); } else { volLast=prefs.sound; setDimValue('sound','off'); volClose(); } }
  if(volWrap && volTrack){
    volWrap.querySelectorAll('[data-vol-step]').forEach(function(b){ b.addEventListener('click', function(e){ e.stopPropagation(); step('sound', +b.getAttribute('data-vol-step')); }); });
    (function(){ var drag=false, last=-1;
      function lvlFromX(x){ var el=volRail||volTrack, r=el.getBoundingClientRect(); var f=r.width?(x-r.left)/r.width:0; return Math.max(0,Math.min(5,Math.round(f*5))); }
      function applyX(x){ var l=lvlFromX(x); if(l===last) return; last=l; setDimValue('sound', CYC.sound[l]); HAPT('tick'); }
      volTrack.addEventListener('pointerdown', function(e){ e.stopPropagation(); e.preventDefault(); drag=true; last=-1; try{ volTrack.setPointerCapture(e.pointerId); }catch(_){} applyX(e.clientX); });
      volTrack.addEventListener('pointermove', function(e){ if(drag) applyX(e.clientX); });
      volTrack.addEventListener('pointerup', function(){ drag=false; });
      volTrack.addEventListener('pointercancel', function(){ drag=false; });
      volTrack.addEventListener('click', function(e){ e.stopPropagation(); });
      volTrack.addEventListener('keydown', function(e){ if(e.key==='ArrowLeft'||e.key==='ArrowDown'){ step('sound',-1); e.preventDefault(); } else if(e.key==='ArrowRight'||e.key==='ArrowUp'){ step('sound',1); e.preventDefault(); } });
    })();
    updateVol();
  }

  // "more" disclosure (holds Text)
  (function(){ var more=document.getElementById('pa-more'), moreT=document.getElementById('pa-more-toggle'); if(more&&moreT){ moreT.addEventListener('click', function(e){ e.stopPropagation(); var open=more.hasAttribute('hidden'); if(open){ more.removeAttribute('hidden'); } else { more.setAttribute('hidden',''); } moreT.setAttribute('aria-expanded', open?'true':'false'); }); } })();

  // The atmosphere is resolved ONCE on arrival and held for the whole visit — no mid-session morphing.

  // ===== Segmented picker — show options, tap one to select. Colored = active. Wires to the engine. =====
  (function(){
    var segs=document.querySelectorAll('.pa11y .pa-seg[data-dim]'); if(!segs.length) return;
    function refreshSeg(){
      segs.forEach(function(seg){
        var dim=seg.getAttribute('data-dim');
        if(dim==='effects'){
          seg.querySelectorAll('.pa-opt[data-fx]').forEach(function(o){
            var fx=o.getAttribute('data-fx'), on=false;
            if(fx==='sound') on=(prefs.sound!=='off');
            else if(fx==='motion') on=((prefs.motion||'on')==='on');
            else if(fx==='fire') on=(html.getAttribute('data-pa-fire')==='on');
            o.setAttribute('data-on', on?'1':'0');
          });
          return;
        }
        if(dim==='weather'){
          var wf=weatherFlags(), wAuto=(prefs.weather==='auto');
          seg.querySelectorAll('.pa-opt[data-val]').forEach(function(o){
            var wv=o.getAttribute('data-val'), on=false;
            if(wv==='auto') on=wAuto;                  // Auto = let the mode decide
            else if(wAuto) on=false;                    // in Auto, only Auto lights
            else if(wv==='clear') on=(!wf.rain && !wf.aurora);
            else on=!!wf[wv];                           // Rain / Aurora light independently — both can be on
            o.setAttribute('data-on', on?'1':'0');
          });
          return;
        }
        var cur=prefs[dim]||CYC[dim][0];
        seg.querySelectorAll('.pa-opt[data-val]').forEach(function(o){ o.setAttribute('data-on', o.getAttribute('data-val')===cur?'1':'0'); });
      });
    }
    segSync=refreshSeg;   // refresh() calls this so bar drags / −/+ keep the Sound pip in sync
    segs.forEach(function(seg){ var dim=seg.getAttribute('data-dim');
      seg.querySelectorAll('.pa-opt').forEach(function(o){
        o.addEventListener('click', function(e){ e.stopPropagation(); var fx=o.getAttribute('data-fx');
          if(fx==='sound'){ soundToggle(); }
          else if(fx==='motion'){ setDimValue('motion', (prefs.motion||'on')==='on'?'off':'on'); }
          else if(fx==='fire'){ toggleHearth(); }
          else if(dim==='weather'){
            var wv2=o.getAttribute('data-val');
            if(wv2==='auto'||wv2==='clear'){ setDimValue('weather', wv2); }
            else { var wf2=weatherFlags(); wf2[wv2]=!wf2[wv2]; setDimValue('weather', weatherToken(wf2)); }
          }
          else { setDimValue(dim, o.getAttribute('data-val')); }
          HAPT('tick'); refreshSeg();
          if(!REDUCE && GS){ var g=o.querySelector('svg')||o.querySelector('span'); if(g){ GS.killTweensOf(g); GS.fromTo(g,{scale:.7},{scale:1,duration:.44,ease:'back.out(2.6)',clearProps:'transform'}); } }
        });
      });
    });
    refreshSeg();
  })();

  // collapsed pill open/close + first-visit invite breath (until first open)
  var root=document.querySelector('.pa11y'), trigger=document.getElementById('pa11y-trigger');
  if(root&&trigger){
    var SEEN='peakherbs_attune_seen', ind2=document.getElementById('pa-indicator'), inviteTimer;
    var firstVisit=false; try{ firstVisit=!localStorage.getItem(SEEN); }catch(e){}
    if(firstVisit){
      root.classList.add('pa11y--invite');   // first visit: the one-shot glow alone invites — no nudge text (Aurre: "no words, less pushy")
    }
    function dropInvite(){ clearTimeout(inviteTimer);
      if(root.classList.contains('pa11y--invite')){ root.classList.remove('pa11y--invite'); try{ localStorage.setItem(SEEN,'1'); }catch(e){} }
      if(ind2) ind2.textContent=indicatorText(); }
    // quiet staggered reveal of the panel contents on open (GSAP; instant when absent / reduced-motion)
    function staggerIn(){ if(!GS) return; var items=root.querySelectorAll('.pa11y__panel > *'); if(items.length) GS.fromTo(items,{y:7,opacity:0},{y:0,opacity:1,duration:.42,ease:'power3.out',stagger:0.045,clearProps:'transform,opacity'}); }
    function openP(){ root.setAttribute('data-open',''); trigger.setAttribute('aria-expanded','true'); dropInvite(); staggerIn(); }
    function closeP(){ root.removeAttribute('data-open'); trigger.setAttribute('aria-expanded','false'); }
    trigger.addEventListener('click', function(e){ e.stopPropagation(); if(root.hasAttribute('data-open')) closeP(); else openP(); });
    document.addEventListener('pointerdown', function(e){ if(root.hasAttribute('data-open') && !root.contains(e.target)) closeP(); });   // pointerdown (not click): on iOS the haptic helper's synthetic .click() bubbles here and was closing the panel on every option tap
    document.addEventListener('keydown', function(e){ if(e.key==='Escape' && root.hasAttribute('data-open')) closeP(); });

    // Mobile: swipe the bottom sheet down to dismiss (drag from the grab handle / non-interactive area).
    var panel=document.getElementById('pa11y-panel');
    if(panel){
      var sy=0, dy=0, swiping=false;
      function mobile(){ try{ return matchMedia('(max-width:640px)').matches; }catch(e){ return false; } }
      function interactive(t){ return !!(t && t.closest && t.closest('.pa-arrow,.pa-meter,.pa-hearth,.pa-more-toggle,button,.pa-vol')); }
      panel.addEventListener('pointerdown', function(e){
        if(!mobile() || !root.hasAttribute('data-open') || interactive(e.target)) return;
        swiping=true; sy=e.clientY; dy=0; panel.style.transition='none'; try{ panel.setPointerCapture(e.pointerId); }catch(_){}
      });
      panel.addEventListener('pointermove', function(e){ if(!swiping) return; dy=Math.max(0, e.clientY-sy); panel.style.transform='translateY('+dy+'px)'; });
      function endSwipe(){ if(!swiping) return; swiping=false; panel.style.transition=''; panel.style.transform=''; if(dy>78) closeP(); dy=0; }
      panel.addEventListener('pointerup', endSwipe);
      panel.addEventListener('pointercancel', endSwipe);
    }
  }

  // Pause ambience when the tab is hidden — FADE gently out and back in, never an abrupt cut.
  document.addEventListener('visibilitychange', function(){
    if(prefs.sound==='off') return;
    if(document.hidden){
      if(act) fade(act, act.volume, 0, 600, function(){ try{act.pause();}catch(e){} });
      if(sby){ try{sby.pause();}catch(e){} }
      if(fireOn && fireAudio) fade(fireAudio, fireAudio.volume||0, 0, 600, function(){ try{fireAudio.pause();}catch(e){} });
    } else {
      if(act){ act.volume=0; var p=act.play(); if(p&&p.catch)p.catch(function(){}); fade(act,0,VOL,900); }
      if(fireOn && fireAudio){ fireAudio.volume=0; var pf=fireAudio.play(); if(pf&&pf.catch)pf.catch(function(){}); fade(fireAudio,0,VOL*0.9,900); }
    }
  });
})();

// ---- Option feedback: a label pops up right at the icon you tap, in its colour, then fades — feedback where your eyes already are (replaces the bottom caption). ----
(function(){
  var root=document.querySelector('.pa11y'), panel=document.getElementById('pa11y-panel');
  if(!root||!panel) return;
  var pop=document.createElement('div'); pop.className='pa-pop'; pop.setAttribute('role','status'); pop.setAttribute('aria-live','polite');
  (document.body||document.documentElement).appendChild(pop);
  var rmode=window.__paResolveMode||function(m){return m==='auto'?'light':m;};
  var rwx=window.__paResolveWeather||function(w,m){ if(w&&w!=='auto')return w; if(m==='dark')return'aurora'; if(m==='dim')return'rain'; return'clear'; };
  var MODE={auto:'Auto',light:'Daybreak',dim:'Dusk',dark:'Nightfall'}, WX={auto:'Auto',clear:'Clear',rain:'Rain',aurora:'Aurora'};
  var NAME={'mode:auto':'Auto','mode:light':'Daybreak','mode:dim':'Dusk','mode:dark':'Nightfall',
    'weather:auto':'Auto','weather:clear':'Clear','weather:rain':'Rain','weather:aurora':'Aurora',
    'fx:sound':'Sound','fx:motion':'Motion','fx:fire':'Hearth',
    'text:md':'Normal','text:lg':'Large','text:xl':'X-Large'};
  function keyOf(o){ var fx=o.getAttribute('data-fx'); if(fx) return 'fx:'+fx;
    var seg=o.closest('.pa-seg'); return (seg?seg.getAttribute('data-dim'):'')+':'+o.getAttribute('data-val'); }
  function labelOf(o){ var k=keyOf(o), name=NAME[k]||'', extra='', P=window.__paPrefs||{};
    if(k==='mode:auto') extra=' · '+(MODE[rmode('auto')]||'');
    else if(k==='weather:auto') extra=' · '+(WX[rwx('auto', document.documentElement.getAttribute('data-pa-mode')||'light')]||'');
    else if(k==='fx:sound') extra=' · '+((P.sound&&P.sound!=='off')?('level '+P.sound):'off');
    else if(k==='fx:motion') extra=' · '+(((P.motion||'on')==='on')?'on':'off');
    else if(k==='fx:fire') extra=' · '+((document.documentElement.getAttribute('data-pa-fire')==='on')?'lit':'off');
    return name+extra; }
  var hideT;
  function place(o){
    var r=o.getBoundingClientRect(), pr=panel.getBoundingClientRect();
    var below=(r.top - pr.top) < 54;                          // top row drops below the icon so it never clips the header
    pop.classList.toggle('pa-pop--below', below);
    var pw=pop.offsetWidth||60, vw=window.innerWidth||document.documentElement.clientWidth;
    pop.style.left=Math.max(pw/2+8, Math.min(vw-pw/2-8, r.left+r.width/2))+'px';
    pop.style.top=(below ? r.bottom+9 : r.top-9)+'px';
  }
  function show(o){
    var t=labelOf(o); if(!t) return;
    pop.textContent=t;
    var col=getComputedStyle(o).getPropertyValue('--opt-col').trim();
    pop.style.setProperty('--pop-col', col||'var(--pa-accent)');
    pop.classList.remove('pa-pop--in'); void pop.offsetWidth;   // restart the pop
    place(o);
    pop.classList.add('pa-pop--in');
    clearTimeout(hideT); hideT=setTimeout(function(){ pop.classList.remove('pa-pop--in'); }, 1600);
  }
  function hide(){ pop.classList.remove('pa-pop--in'); }
  root.querySelectorAll('.pa-opt').forEach(function(o){
    o.addEventListener('click', function(){ show(o); });
    o.addEventListener('focus', function(){ show(o); });
  });
  window.addEventListener('scroll', hide, {passive:true});
  window.addEventListener('resize', hide);
  try{ new MutationObserver(function(){ if(!root.hasAttribute('data-open')) hide(); }).observe(root,{attributes:true,attributeFilter:['data-open']}); }catch(e){}
})();

// ---- Signup "Bloom" — adaptive magic moment on email submit. Standalone; the page calls window.peakBloom(). ----
window.peakBloom = function(){
  try{
    var html=document.documentElement, reduce=false;
    try{ reduce=matchMedia('(prefers-reduced-motion: reduce)').matches; }catch(e){}
    if(reduce) return;
    var bloom=document.getElementById('pa-bloom'); if(!bloom) return;
    try{ if(navigator.vibrate && matchMedia('(pointer: coarse)').matches) navigator.vibrate(12); }catch(e){}   // gentle haptic confirm on mobile
    var mode=html.getAttribute('data-pa-mode')||'light';
    var bx='50%', by='44%', mark=document.querySelector('.hero__mark');
    if(mark){ var r=mark.getBoundingClientRect(); bx=(r.left+r.width/2).toFixed(0)+'px'; by=(r.top+r.height/2).toFixed(0)+'px';
      // pulse the mark AFTER its entrance reveal settles (~1s) — firing it immediately overrode paReveal mid-rise → the hop/jump (Aurre)
      setTimeout(function(){ mark.classList.remove('pa-pulse'); void mark.offsetWidth; mark.classList.add('pa-pulse'); setTimeout(function(){ mark.classList.remove('pa-pulse'); },1000); }, 1150); }
    var bloomCol = mode==='dark' ? 'rgba(150,240,205,.42)' : mode==='dim' ? 'rgba(255,206,150,.40)' : 'rgba(255,240,212,.82)';
    var sparkCol = mode==='dark' ? 'rgba(150,240,205,.95)' : mode==='dim' ? 'rgba(255,200,140,.95)' : 'rgba(62,155,110,.95)';
    bloom.style.setProperty('--bx',bx); bloom.style.setProperty('--by',by);
    bloom.style.setProperty('--bloom-col',bloomCol); bloom.style.setProperty('--spark-col',sparkCol);
    bloom.innerHTML='';
    var glow=document.createElement('div'); glow.className='pa-bloom__glow'; bloom.appendChild(glow);    var n = mode==='dark'?7:(mode==='dim'?13:0);   // fewer night sparks so the shooting star is the moment
    for(var i=0;i<n;i++){
      var s=document.createElement('span'); s.className='pa-spark';
      var ang=Math.random()*6.283, dist=55+Math.random()*135;
      s.style.setProperty('--sdx',(Math.cos(ang)*dist).toFixed(0)+'px');
      s.style.setProperty('--sdy',(-Math.abs(Math.sin(ang))*dist-55).toFixed(0)+'px');
      s.style.setProperty('--sdur',(1.5+Math.random()*0.9).toFixed(2)+'s');
      s.style.setProperty('--sdelay',(Math.random()*0.3).toFixed(2)+'s');
      bloom.appendChild(s);
    }
    if(mode==='dark'){   // a slow, sparse shower — a few stars drift through over ~45s, each in its OWN rotated frame (trail always aligned). Own fixed layer + self-removes.
      var sky=document.createElement('div'); sky.className='pa-shoot';
      var SHOOT=1, lastEnd=0;   // ONE star — multiple reading the same direction looked fake (Aurre). If more are ever wanted, vary the angle/origin per star, not just spawn copies.
      for(var si=0; si<SHOOT; si++){
        var trk=document.createElement('div'); trk.className='pa-shoot__trk';
        var hd=document.createElement('div'); hd.className='pa-shoot__hd';
        var sdur=19+Math.random()*7;                 // 19-26s slow drift (Aurre approved keeper; "slightly slower")
        var sdelay=0.6 + si*(9+Math.random()*4);     // staggered: ~0.6s, ~11s, ~22s
        trk.style.setProperty('--sang',(18+Math.random()*17).toFixed(1)+'deg');   // varied 18-35 deg
        trk.style.setProperty('--sx',(6+Math.random()*36).toFixed(0)+'%');         // varied start, upper-left -> centre
        trk.style.setProperty('--sy',(7+Math.random()*17).toFixed(0)+'%');
        hd.style.setProperty('--sdur',sdur.toFixed(1)+'s');
        hd.style.setProperty('--sdelay',sdelay.toFixed(1)+'s');
        hd.style.setProperty('--sdist',(78+Math.random()*16).toFixed(0)+'vmax');
        hd.style.setProperty('--strail',(250+Math.random()*90).toFixed(0)+'px');   // varied trail length
        trk.appendChild(hd); sky.appendChild(trk);
        if(sdelay+sdur>lastEnd) lastEnd=sdelay+sdur;
      }
      (document.body||document.documentElement).appendChild(sky);
      setTimeout(function(){ if(sky.parentNode) sky.parentNode.removeChild(sky); }, (lastEnd*1000)+1800);
    }
    html.classList.add('pa-swell'); setTimeout(function(){ html.classList.remove('pa-swell'); },1800);
    setTimeout(function(){ bloom.innerHTML=''; },3400);   // hold long enough for the slow star to finish its arc
  }catch(e){}
};
